import { Component, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { APP_LOGO_URL, APP_NAME } from '@admin-core/constants/app.constants';
import { AuthService } from '@admin-core/services/auth.service';
import { TranslatePipe } from '@admin-core/i18n/translate.pipe';
import { TranslationKey } from '@admin-core/i18n/translations/en';
import { LanguageSwitcherComponent } from '@admin-shared/components/language-switcher/language-switcher.component';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [ReactiveFormsModule, RouterLink, TranslatePipe, LanguageSwitcherComponent],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  readonly appName = APP_NAME;
  readonly logoUrl = APP_LOGO_URL;
  readonly submitting = signal(false);
  readonly sent = signal(false);
  readonly error = signal<TranslationKey | null>(null);
  readonly form;

  constructor(
    private readonly fb: FormBuilder,
    private readonly auth: AuthService
  ) {
    this.form = this.fb.nonNullable.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.submitting.set(true);
    this.error.set(null);
    this.auth.requestPasswordReset(this.form.getRawValue().email).subscribe({
      next: () => {
        this.submitting.set(false);
        this.sent.set(true);
      },
      error: () => {
        this.submitting.set(false);
        this.error.set('passwordReset.requestError');
      }
    });
  }
}
